import { AxiosRequestConfig } from "axios";

import { LOCAL_STORAGE } from "@constants";
import { User } from "@contexts/Auth";

export const authTokenRequestInterceptor = (config: AxiosRequestConfig) => {
  const userJSON = localStorage.getItem(LOCAL_STORAGE.USER);

  if (userJSON) {
    const { accessToken } = JSON.parse(userJSON) as User;

    if (accessToken) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      };
    }
  }

  return config;
};
